export default "__VITE_ASSET__0b97ad47__"